import { useState, useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@mui/x-data-grid";
import { getsupplierrecord, getsupplierbookingrecord, fetchCurrencyData, analyzedocs, getanalyzedocsresult} from "../api/customerapi";
import {
    Paper,
    FormControl,
    Button,
    TextField,
    InputLabel,
    Select,
    MenuItem,
    Typography,
  } from "@material-ui/core";
import {CSVLink} from "react-csv"

  const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2),
      width: theme.spacing(30),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: "left",
    },
    headertext: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(3),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(24),
      height: theme.spacing(5),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      fontSize: 14,
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(24),
      height: theme.spacing(5),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      fontSize: 14,
    },
  })); 

const Supplierdatarecord = () => {
    const classes = useStyles();
    const width = window.innerWidth - 200;
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    const [selection, setselection] = useState([]);
    const [oldcurrency, setoldcurrency]=useState({})
    const columns = [
        
       
          {
              field: "trip_id",
              headerName: "Trip Id",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "amount",
              headerName: "Amount",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "date",
              headerName: "Date",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "status",
              headerName: "Status",
              width: width / 12,
              cellClassName: "gridcell",
            },
            {
              field: "details",
              headerName: "Details",
              width: width / 12,
              cellClassName: "gridcell",
            },
            
        ];
    const columns2 = [
            {
                field: "trip_id",
                headerName: "Trip Id",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "amount",
                headerName: "Amount",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "date",
                headerName: "Date",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "status",
                headerName: "Status",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "start_date",
                headerName: "Trip Start Date",
                width: width / 12,
                cellClassName: "gridcell",
              },
               {
                field: "trip_score",
                headerName: "PT Score",
                width: width / 12,
                cellClassName: "gridcell",
              },
               {
                field: "land_issue",
                headerName: "Land Issue",
                width: width / 12,
                cellClassName: "gridcell",
              },
               {
                field: "supplier_issue",
                headerName: "Supplier Issue",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "destination",
                headerName: "Destination",
                width: width / 12,
                cellClassName: "gridcell",
              },
          ];

          const columns3 = [
            {
                field: "trip_id",
                headerName: "Trip Id",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "start_date",
                headerName: "Trip Start Date",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "cust_name",
                headerName: "Name",
                width: width / 12*2,
                cellClassName: "gridcell",
              },
              {
                field: "all_clear",
                headerName: "All Clear",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "currency",
                headerName: "Currency",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "currency_value",
                headerName: "Value",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "roe",
                headerName: "RoE",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "calc_amount",
                headerName: "Calc Amount",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "crm_amount",
                headerName: "CRM Amount",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "details",
                headerName: "Details",
                width: width / 12*2,
                cellClassName: "gridcell",
              },
              {
                field: "primary_mobile_number",
                headerName: "Mobile",
                width: width / 12,
                cellClassName: "gridcell",
              },
              {
                field: "passport",
                headerName: "Passport",
                width: width / 12*4,
                cellClassName: "gridcell",
              },
              {
                field: "pan",
                headerName: "PAN",
                width: width / 12*4,
                cellClassName: "gridcell",
              },
              
              
          ];
    const [searchData, setsearchData] = useState([{}]);
    const [searchData2, setsearchData2] = useState([{}]);
    const [listpaymenttripData, setlistpaymenttripData] = useState([]);
    const [listbookingtripData, setlistbookingtripData] = useState([]);
    const [showtable3, setshowtable3] = useState(false);
    const [analyticsdatalistdisplay3, setanalyticsdatalistdisplay3] = useState([]);

    const headers=[
        
        {label:"Trip Id", key:"trip_id"},
        {label:"Amount", key:"amount"},
        {label:"Date", key:"date"},
       
        {label:"Status", key:"status"},
        {label:"Details", key:"details"},
    ]

    const headers2=[
        
        {label:"Trip Id", key:"trip_id"},
        {label:"Amount", key:"amount"},
        {label:"Date", key:"date"},
        {label:"Destination", key:"destination"},
        {label:"Status", key:"status"},
        {label:"Trip Start", key:"start_date"},
        {label:"PT Score", key:"trip_score"},
        {label:"Land Issue", key:"land_issue"},
        {label:"Supplier Issue", key:"supplier_issue"},
    ]

    const headers3=[
        
      {label:"Trip Id", key:"trip_id"},
      {label:"Trip Start", key:"start_date"},
      {label:"Customer Name", key:"cust_name"},
      {label:"All Clear", key:"all_clear"},
      {label:"Curreny", key:"currency"},
      {label:"Curreny Value", key:"currency_value"},
      {label:"RoE", key:"roe"},
      {label:"Calculated Amount", key:"calc_amount"},
      {label:"CRM Amount", key:"crm_amount"},
      {label:"Details", key:"details"},
      {label:"Mobile", key:"primary_mobile_number"},
      {label:"PAN", key:"pan"},
      {label:"Passport", key:"passport"},
  ]

    const paymentsearch=async()=>{
        try{
            if(searchData.start_date && searchData.end_date) {
                const temp=currentid.replaceAll("%20"," ")
                const data=await getsupplierrecord(searchData.start_date, searchData.end_date, temp)
                console.log(data.data)
                setlistpaymenttripData(data.data)
            }

        }catch(err){
            console.log(err)
        }
    }

    const bookingsearch=async()=>{
        try{
          var temp=""
            if(searchData2.start_date && searchData2.end_date) {
              // const temp2=currentid.trim()
                temp=currentid.replaceAll("%20"," ")
                
                const data=await getsupplierbookingrecord(searchData2.start_date, searchData2.end_date, temp)
                console.log(data.data)
                setlistbookingtripData(data.data)
            }

        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
      getCurrency()
      //getVisa()
      //getDest()
  }, [])

    const gridcellclick=(id)=>{
        window.open("/tripdataentry/" + id+"/paymentupdate", '_blank');
        //console.log("/custdataentry/"+id);
      }

    const getCurrency = async()=>{
      try{
      const data= await fetchCurrencyData();
      console.log(data.data[0])
      setoldcurrency(data.data[0])
    }catch(err){
      console.log(err)
  }
    }

    const getroe=(value)=>{
      if(value=="USD"){
        return oldcurrency.usd_inr
      }else if(value=="SGD"){
        return oldcurrency.sgd_inr
      }else if(value=="EUR"){
        return oldcurrency.eur_inr
      }else if(value=="THB"){
        return oldcurrency.thb_inr
      }else if(value=="AED"){
        return oldcurrency.aed_inr
      }else if(value=="IDR"){
        return oldcurrency.idr_inr
      }else{
        return 0
      }
    }

    const analyticsdatalistdisplay = listpaymenttripData.map((tripdata) => ({
        trip_id:tripdata.trip_id,
        id: listpaymenttripData.indexOf(tripdata),
        status:tripdata.supplier_payments.status,
        amount:tripdata.supplier_payments.amount,
        date:tripdata.supplier_payments.date.split('T').slice(0,1),
        details:tripdata.supplier_payments.details
      }));

      const analyticsdatalistdisplay2 = listbookingtripData.map((tripdata) => ({
        trip_id:tripdata.trip_id,
        id: listbookingtripData.indexOf(tripdata),
        status:tripdata.supplier_payments.status,
        amount:tripdata.supplier_payments.amount,
        details:tripdata.supplier_payments.details,
        date:tripdata.supplier_payments.date.split('T').slice(0,1),
        start_date:tripdata.trip_start_date.split('T').slice(0,1),
        cust_name:tripdata.cust_name,
        primary_mobile_number:tripdata.primary_mobile_number,
        all_clear:tripdata.all_clear,
        destination: tripdata.primary_destination,
        currency:"currency" in tripdata.supplier_payments?tripdata.supplier_payments.currency:"",
        currency_value:"currency_value" in tripdata.supplier_payments?tripdata.supplier_payments.currency_value:0,
        supplier_issue:"review_supplier_issue" in tripdata?tripdata.review_supplier_issue:"",
        land_issue:"review_land_issue" in tripdata?tripdata.review_land_issue:"",
        trip_score:"post_trip_score" in tripdata?tripdata.post_trip_score:"",
      }));

    const getpan=async(tripid)=>{
      try{
        console.log(tripid)
        var temparr=""
        const temp=listbookingtripData.filter(d=>d.trip_id==tripid)
        const filelist="file" in temp[0] && temp[0].file.length>0?temp[0].file.filter(f=>f.type_of_doc=="PAN"):""
        //console.log(filelist)
        if(filelist.length>0){
        for(let i=0; i<filelist.length; i++){
          const loc=filelist[i].location
          const pan=await scandocs(loc)
          //console.log(pan)
          temparr=(temparr.length==0?pan:temparr+" || "+pan)
        }
        console.log(temparr)
        return temparr
      }else{
        return "xyz"
      }
      }catch(e){
        console.log(e)
      }
    }

    const getpassport=async(tripid)=>{
      try{
        console.log(tripid)
        var temparr=""
        const temp=listbookingtripData.filter(d=>d.trip_id==tripid)
        const filelist="file" in temp[0] && temp[0].file.length>0?temp[0].file.filter(f=>f.type_of_doc=="Passport"):""
        //console.log(filelist)
        if(filelist.length>0){
        for(let i=0; i<filelist.length; i++){
          const loc=filelist[i].location
          const passport=await scandocs2(loc)
          //console.log(passport)
          temparr=(temparr.length==0?passport:temparr+" || "+passport)
        }
        console.log(temparr)
        return temparr
      }else{
        return "xyz"
      }
      }catch(e){
        console.log(e)
      }
    }

    const scandocs=async(loc)=>{
     var panstring=""
    const temp=loc.split("amazonaws.com/")
    const temp2=temp[temp.length-1]
    const documentKey=temp2.replaceAll("%20"," ").replaceAll("%28","(").replaceAll("%29",")")
    console.log(documentKey)
    const extension = documentKey.split('.').pop().toLowerCase();
    //console.log(extension)
    const panpattern = /\b[a-zA-Z]{5}\d{4}[a-zA-Z]\b/g;
  
    if(extension=="pdf"){
      const data=await analyzedocs(documentKey)
      //console.log(data.data)
     
      const data2=await getanalyzedocsresult(data.data.blocks)
      //console.log(data2.data)
      if("results" in data2.data && "Blocks" in data2.data.results){
        var text=""
        for(let i=0;i<data2.data.results.Blocks.length;i++){
          if(data2.data.results.Blocks[i].BlockType=="WORD" || data2.data.results.Blocks[i].BlockType=="LINE"){
          text=text+data2.data.results.Blocks[i].Text+" || "
          }
        }
        //console.log(text)
        const panmatches = text.match(panpattern);
        console.log(panmatches)
       
        if(panmatches && panmatches.length>0){
          panstring=(panmatches.toString())
        }
      }
    }else{
    const data=await analyzedocs(documentKey)
    //console.log(data.data)
    if("blocks" in data.data){
    const temp3=data.data.blocks.filter(b=>b.BlockType=="WORD")
    //console.log(temp3)
    var text=""
    for(let i=0;i<temp3.length;i++){
      text=text+temp3[i].Text+" || "
    }
    const panmatches = text.match(panpattern);
    console.log(panmatches)
   
    if(panmatches && panmatches.length>0){
      panstring=(panmatches.toString())
      console.log(panstring)
    }
    }
    
    }
    return panstring
  }

  const scandocs2=async(loc)=>{
    var panstring=""
   const temp=loc.split("amazonaws.com/")
   const temp2=temp[temp.length-1]
   const documentKey=temp2.replaceAll("%20"," ").replaceAll("%28","(").replaceAll("%29",")")
   console.log(documentKey)
   const extension = documentKey.split('.').pop().toLowerCase();
   //console.log(extension)
   const passportpattern = /\b[a-zA-Z]\d{7}\b/g;
 
   if(extension=="pdf"){
     const data=await analyzedocs(documentKey)
     //console.log(data.data)
    
     const data2=await getanalyzedocsresult(data.data.blocks)
     //console.log(data2.data)
     if("results" in data2.data && "Blocks" in data2.data.results){
       var text=""
       for(let i=0;i<data2.data.results.Blocks.length;i++){
         if(data2.data.results.Blocks[i].BlockType=="WORD" || data2.data.results.Blocks[i].BlockType=="LINE"){
         text=text+data2.data.results.Blocks[i].Text+" || "
         }
       }
       //console.log(text)
       const passportmatches = text.match(passportpattern);
       console.log(passportmatches)
      
       if(passportmatches && passportmatches.length>0){
         panstring=(passportmatches.toString())
       }
     }
   }else{
   const data=await analyzedocs(documentKey)
   //console.log(data.data)
   if("blocks" in data.data){
   const temp3=data.data.blocks.filter(b=>b.BlockType=="WORD")
   //console.log(temp3)
   var text=""
   for(let i=0;i<temp3.length;i++){
     text=text+temp3[i].Text+" || "
   }
   const passportmatches = text.match(passportpattern);
   console.log(passportmatches)
  
   if(passportmatches && passportmatches.length>0){
     panstring=(passportmatches.toString())
     console.log(panstring)
   }
   }
   
   }
   return panstring
 }


    const  generateremiitancetable=async()=>{
      
      //console.log(analyticsdatalistdisplay2)
      var remtable=[]
      for(let i=0; i<selection.length; i++){
        var temp={
          trip_id:analyticsdatalistdisplay2[selection[i]].trip_id,
          cust_name:analyticsdatalistdisplay2[selection[i]].cust_name,
          primary_mobile_number:analyticsdatalistdisplay2[selection[i]].primary_mobile_number,
          start_date:analyticsdatalistdisplay2[selection[i]].start_date,
          crm_amount:analyticsdatalistdisplay2[selection[i]].amount,
          all_clear:analyticsdatalistdisplay2[selection[i]].all_clear,
          currency:analyticsdatalistdisplay2[selection[i]].currency,
          currency_value:analyticsdatalistdisplay2[selection[i]].currency_value,
          roe:getroe(analyticsdatalistdisplay2[selection[i]].currency),
          calc_amount:(getroe(analyticsdatalistdisplay2[selection[i]].currency)*analyticsdatalistdisplay2[selection[i]].currency_value).toFixed(1),
          passport:await getpassport(analyticsdatalistdisplay2[selection[i]].trip_id),
          pan:await getpan(analyticsdatalistdisplay2[selection[i]].trip_id),
          details:analyticsdatalistdisplay2[selection[i]].details,
          id:i,
        }
      remtable=[...remtable, temp]
      }
      //console.log(remtable)
      setanalyticsdatalistdisplay3(remtable)
      setshowtable3(true)
    }

    return(
        <div>
<Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Supplier Payment Data
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Payment Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData({
                      ...searchData,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Payment Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData({ ...searchData, end_date: e.target.value })
                  }
                />
               
                
                <Button
                  onClick={paymentsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
                
                
                 {analyticsdatalistdisplay.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
              </div>
              {analyticsdatalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay}
                    columns={columns}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
                      gridcellclick(getValue.row.trip_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>

            <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Supplier Booking Data
              </Typography>
              <div align="center">
                <TextField
                  variant="outlined"
                  type="date"
                  label="Start Date On or after"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData2({
                      ...searchData2,
                      start_date: e.target.value,
                    })
                  }
                />

                <TextField
                  variant="outlined"
                  type="date"
                  label="Start Date On or before"
                  className={classes.textField}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    setsearchData2({ ...searchData2, end_date: e.target.value })
                  }
                />
               
                
                <Button
                  onClick={bookingsearch}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Load
                </Button>
                {analyticsdatalistdisplay2.length>0?(
                <Button
                  onClick={generateremiitancetable}
                  color="secondary"
                  variant="contained"
                  className={classes.button}
                >
                  Remittance
                </Button>
              ):("")}
                
                 {analyticsdatalistdisplay2.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay2} headers={headers2}>Download CSV</CSVLink>
                   </div>
                ):("")}
              </div>
              {analyticsdatalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay2}
                    columns={columns2}
                    autoPageSize
                    checkboxSelection={true}
            onSelectionModelChange={(newSelection) => {
        setselection(newSelection);}}
                    onCellDoubleClick={(getValue) =>
                      gridcellclick(getValue.row.trip_id)
            }
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </Paper>

            {showtable3 && analyticsdatalistdisplay3.length > 0 ?(
              <Paper variant="outlined" className={classes.paper} elevation={10}>
              <Typography
                variant="h4"
                align="center"
                className={classes.headertext}
              >
                {" "}
                Remittance Table
              </Typography>
              {analyticsdatalistdisplay3.length>0?(<div>
                   <CSVLink data={analyticsdatalistdisplay3} headers={headers3}>Download CSV</CSVLink>
                   </div>
                ):("")}
          
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={analyticsdatalistdisplay3}
                    columns={columns3}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
                      gridcellclick(getValue.row.trip_id)
                    }
                  ></DataGrid>
                </div>
              
            </Paper>
            ):("")}
        </div>
    )
}

export default Supplierdatarecord;